module.exports = __webpack_public_path__ + "img/goal-img1.f8814362.png";